import { useGetCertificate } from "@/api/app/certification/useGetCertificate";
import LoadingScreen from "@/components/Loading";
import { Button } from "@/components/ui/button.tsx";
import { handleCompanyName } from "@/lib/handleName";
import { format } from "date-fns";
import * as htmlToImage from "html-to-image";
import { jsPDF } from "jspdf";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

function CertificatePage() {
  const [isPrinting, setPrinting] = useState(false);
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { data, isLoading } = useGetCertificate();

  if (isLoading) {
    return <LoadingScreen />;
  }
  if (!data) {
    navigate("/app/assessment");
    return null;
  }
  const {
    company_id,
    issued_at,
    company_name,
    registration_number,
    company_address,
    score,
  } = data.data;
  const starCount = (() => {
    if (score >= 630) return 3;
    if (score >= 560) return 2;
    if (score >= 420) return 1;
    return 0;
  })();

  const starLabel = (() => {
    if (score >= 630) return "三ツ星";
    if (score >= 560) return "二ツ星";
    if (score >= 420) return "一ツ星";
    return "C";
  })();

  const handleDownload = (callback: any) => {
    const ele = document.getElementById("premium-certificate");
    if (!ele) return;
    htmlToImage
      .toPng(ele, { quality: 1.0, pixelRatio: 3 })
      .then(function (dataUrl) {
        const docs = new jsPDF({
          orientation: "portrait",
          format: "a4",
        });
        const width = docs.internal.pageSize.width;
        const height = docs.internal.pageSize.height;
        docs.addImage(
          dataUrl,
          "PNG",
          0,
          0,
          width,
          height,
          "premium-certificate",
          "FAST",
        );
        docs.save("certificate-of-completion.pdf");
        callback();
      });
  };

  return (
    <div>
      <div className="flex justify-between px-16 py-4 border-b border-cool-gray-200">
        <span className="text-2xl font-bold">{t("certificate")}</span>
        <Button
          isLoading={isPrinting}
          variant="outline"
          onClick={() => {
            setPrinting(true);
            handleDownload(() => {
              setPrinting(false);
            });
          }}
        >
          {t("download-certificate")}
        </Button>
      </div>
      <div className="flex justify-center flex-col items-center py-8">
        <div className="relative w-max" id="premium-certificate">
          <img src={"/images/premium-2.svg"} alt={"free-bg"} />
          <p className="text-[12px] leading-[18px] text-[#00193F] absolute top-[46px] left-[206px] translate-x-[-50%] font-semibold">
            {registration_number || "--"}
          </p>
          <p className="text-[12px] leading-[18px] text-[#00193F] absolute top-[67px] left-[38.5%] translate-x-[-50%] font-semibold">
            {format(issued_at, t("date-format"))}
          </p>
          <p className="text-[16px] leading-[24px] text-[#00193F] absolute top-[298px] left-[calc(50%_+_32.5px)] translate-x-[-50%] font-semibold whitespace-nowrap">
            一般社団法人国際就労振興協会（IEPA）は以下の事業者を、
          </p>
          <p className="text-[16px] leading-[24px] text-[#00193F] absolute top-[322px] left-[calc(50%_+_32.5px)] translate-x-[-50%] font-semibold whitespace-nowrap">
            {starLabel}外国籍社員適正雇用事業者と認定する
          </p>
          <img
            src={`/images/star-${starCount}.svg`}
            alt={"star"}
            className="absolute top-[400px] left-[calc(50%_+_32.5px)] translate-x-[-50%]"
          />
          <p className="text-[20px] leading-[30px] text-[#00193F] absolute top-[450px] left-[calc(50%_+_32.5px)] translate-x-[-50%] font-semibold">
            {handleCompanyName(company_id, company_name)}
          </p>
          <p className="text-[10px] leading-[12px] text-[#00193F] absolute top-[490px] left-[calc(50%_+_32.5px)] translate-x-[-50%]">
            {company_address || "--"}
          </p>
        </div>
      </div>
    </div>
  );
}

export default CertificatePage;
